import React from "react";
import { Handle, Position } from "reactflow";

const LinkHandler: React.FC<{idx?: string}> = ({idx}) => {
  return (
      <Handle
        type="source"
        position={Position.Right}
        id={idx}
        style={{
          transform: "translateY(-50%)",
          width: 7,
          height: 7,
          background: "#000",
          borderRadius: "50%",
          zIndex: 10,
        }}
      />
  )
}

export default LinkHandler;
